import { getCookies } from "@AccWebsiteBundle/GdprConsent/helpers";

window.getCookies = getCookies;
